export default __webpack_public_path__ + "static/media/banner2.71be2687.jpg";